export default "__VITE_ASSET__d70ce2c1__"